<template>
  <div>
    <div class="slide-one"></div>
    <div class="content-center" style="padding: 40px 0 80px">
      <div class="warp">
        <div class="title">
          <div @click="turnTo('/aboutMe')">关于我们</div>
          <div class="active">加入我们</div>
          <div @click="turnTo('/contactWe')">联系我们</div>
        </div>
        <div class="content">
          <div class="content-title">我们在寻找</div>
          <div class="content-tips">WE ARE FINDING</div>
          <div class="content-p">
            我们期待有梦想,有激情,有创意,有能力的你加入我们,
          </div>
          <div class="content-p">为你提供 “有成长、有舞台、有未来” 的平台!</div>
          <div>
            <div class="content-btn" @click="goPage('https://huolala.zhiye.com/')">产看更多职位>></div>
          </div>
          <div class="content-box-zhiwei">
            点击查看更多岗位跳转到货拉拉招聘页面：
            <span @click="goPage('https://huolala.zhiye.com/')">https://huolala.zhiye.com/</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goPage (val) {
      window.open(val);
    },
    turnTo(path){
      this.$router.push({ path})
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-one {
  height: 520px;
  background: url(../assets/aboutMe.png) no-repeat center;
  background-size: cover;
  position: relative;
}
.content-center {
  width: 1080px;
  margin: 0 auto;
  padding: 10px 50px;
}
.warp {
  display: flex;
  .title {
    width: 100px;
    height: 344px;
    padding-top: 20px;
    border-right: 1px solid #eaeaea;
    font-size: 14px;
    font-weight: 400;
    color: #2f3439;
    line-height: 33px;
    > div {
      padding: 0 13px;
      cursor: pointer;
    }
    .active {
      color: #f16622;
      position: relative;
    }
    .active::before {
      content: "";
      position: absolute;
      top: 10px;
      left: 0;
      width: 2px;
      height: 13px;
      background: #f16622;
    }
  }
  .content {
    flex: 1;
    padding: 0 40px;
    text-align: center;
    .content-title {
      font-size: 24px;
      font-weight: 600;
      color: #2f3439;
      line-height: 46px;
      text-align: center;
    }
    .content-tips {
      font-size: 14px;
      color: #768191;
      line-height: 14px;
      text-align: center;
      margin-bottom: 20px;
    }
    .content-p {
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #768191;
      line-height: 18px;
      text-indent: 2em;
      margin-bottom: 18px;
    }
    .content-btn {
      display: inline-block;
      width: 100px;
      height: 26px;
      background: #f16622;
      border-radius: 2px;
      text-align: center;
      font-size: 12px;
      color: #ffffff;
      line-height: 26px;
      cursor: pointer;
      margin-bottom: 45px;
    }
    .content-box-zhiwei {
      display: inline-block;
      width: 557px;
      border-top: 1px solid #eaeaea;
      font-size: 12px;
      color: #768191;
      line-height: 40px;
      span {
        color: #f16622;
      }
    }
  }
}
</style>